import React from "react";
import usePixModalStyles from "../PixPaymentModal.styles";
import { PixTabsProps } from "../types";
import {
  getPixTabLabel,
  isPixPaid,
} from "@pages/User/MyOrders/utilsOrders/utilsMyOrders";

const currency = (value: number) =>
  value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

/**
 * Barra de abas de Pix (SP-1294 / D3, D6): "Pix 1", "Pix 2", …
 * Cada aba reflete o estado pago/pendente do seu Pix (via regra confiável)
 * e destaca a aba ativa.
 */
const PixTabs: React.FC<PixTabsProps> = ({
  payloads,
  activeIndex,
  onSelect,
}) => {
  const classes = usePixModalStyles();

  return (
    <div className={classes.tabsBar} role="tablist">
      {payloads.map((px, index) => {
        const active = index === activeIndex;
        const paid = isPixPaid(px);
        return (
          <button
            key={px.uuid ?? px.id}
            type="button"
            role="tab"
            aria-selected={active}
            className={`${classes.tab} ${
              active ? classes.tabActive : classes.tabInactive
            }`}
            onClick={() => onSelect(index)}
          >
            <span
              className={`${classes.tabStatusDot} ${
                paid ? classes.tabStatusDotPaid : classes.tabStatusDotPending
              }`}
            />
            <span className={classes.tabLabel}>{getPixTabLabel(index)}</span>
            <span className={classes.tabValue}>{currency(px.valor)}</span>
          </button>
        );
      })}
    </div>
  );
};

export default PixTabs;
